export interface MetricQualityObject {
    // Other than qualities with type QualityValue,
    // there are several properties like `quantity` which we need to ignore in frontend.
    [qualityName: string]: unknown
}

export interface QualityValue {
    value: number
    "ui:name"?: string
    ci: [number, number]
}

export function isQualityValue(value: any): value is QualityValue {
    return (
        typeof value === "object" &&
        value !== null &&
        "value" in value &&
        "ci" in value &&
        Array.isArray(value.ci) &&
        value.ci.length === 2 &&
        typeof value.value === "number" &&
        typeof value.ci[0] === "number" &&
        typeof value.ci[1] === "number" &&
        (!("ui:name" in value) ||
            ("ui:name" in value && typeof value["ui:name"] === "string"))
    )
}
